/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mini_arrow': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3 5.813V5.35L7.27.78 8 0l.73.782L13 5.35v.462l-1.23 1.15L9 3.999v12.466H7V3.999L4.23 6.963 3 5.813z" _fill="#2D6356"/>'
  }
})
